"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CapiAuthTokenResponseToJSON = exports.CapiAuthTokenResponseFromJSONTyped = exports.CapiAuthTokenResponseFromJSON = exports.instanceOfCapiAuthTokenResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CapiAuthTokenResponse interface.
 */
function instanceOfCapiAuthTokenResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCapiAuthTokenResponse = instanceOfCapiAuthTokenResponse;
function CapiAuthTokenResponseFromJSON(json) {
    return CapiAuthTokenResponseFromJSONTyped(json, false);
}
exports.CapiAuthTokenResponseFromJSON = CapiAuthTokenResponseFromJSON;
function CapiAuthTokenResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'capiAuthTokenId': !(0, runtime_1.exists)(json, 'capi_auth_token_id') ? undefined : json['capi_auth_token_id'],
        'capiAuthToken': !(0, runtime_1.exists)(json, 'capi_auth_token') ? undefined : json['capi_auth_token'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
    };
}
exports.CapiAuthTokenResponseFromJSONTyped = CapiAuthTokenResponseFromJSONTyped;
function CapiAuthTokenResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'capi_auth_token_id': value.capiAuthTokenId,
        'capi_auth_token': value.capiAuthToken,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
    };
}
exports.CapiAuthTokenResponseToJSON = CapiAuthTokenResponseToJSON;
